"use strict";
/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", { value: true });
var gateway_request_type_1 = require("./../../services/gateway-control/gateway-request-type");
/**
 * Gateway response from a get services request.
 */
var GetServicesResponse = /** @class */ (function () {
    /**
     * Create a new GetOperationsResponse instance
     *
     * @param services the services
     */
    function GetServicesResponse(services) {
        /**
         * Required for round-trip serialiser tests.
         */
        this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICES;
        this.services = services;
    }
    return GetServicesResponse;
}());
exports.GetServicesResponse = GetServicesResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/get-services-response.js
// module id = 1245
// module chunks = 1